// extracted by mini-css-extract-plugin
export default {"wrapper":"BusinessBanking_wrapper__W5eKA","sidebarWrapper":"BusinessBanking_sidebarWrapper__RmXa-","sectionWrapper":"BusinessBanking_sectionWrapper__TYLsp"};